import { Typography,Box} from "@mui/material"

const CalendarDayName=(props)=>{
    return(
    <Box sx={{width:"100%", backgroundColor: 'neutral.900'}}>
        <Typography sx={{p:3,color:"white",textAlign:"center"}}>{props.children}</Typography>
    </Box>)
}
export default CalendarDayName